/**
 * @fileoverview Resolves the student task behind a lesson activity. The tracker payload only carries
 * activity ids, while the My tasks deliverable drawer works on `student_tasks.id`
 * (`GET /api/session_meeting_activities/:id` → `studentTask.id`, the activity's single task definition).
 */

import { useEffect, useState } from 'react'
import { getActivity } from 'pages/NewProject/service/projects'

interface UseStudentTaskIdResult {
  studentTaskId: string
  resolving: boolean
  failed: boolean
}

export function useStudentTaskId(activityId: string, opened: boolean): UseStudentTaskIdResult {
  const [studentTaskId, setStudentTaskId] = useState('')
  const [resolving, setResolving] = useState(false)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    if (!opened || !activityId) {
      setStudentTaskId('')
      setFailed(false)
      return
    }
    let cancelled = false
    setResolving(true)
    setFailed(false)
    getActivity(activityId)
      .then(activity => {
        if (cancelled) return
        const id: string | undefined = activity?.studentTask?.id
        if (id) setStudentTaskId(id)
        else setFailed(true)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })
      .finally(() => {
        if (!cancelled) setResolving(false)
      })
    return () => {
      cancelled = true
    }
  }, [activityId, opened])

  return { studentTaskId, resolving, failed }
}
